import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5f4c1cbc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container mg-b--15"
};
const _hoisted_3 = {
  class: "table__container",
  ref: "tableContainer"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = {
  class: "btn_list"
};
const _hoisted_6 = {
  class: "table-list",
  ref: "tableWarpRef"
};
import { ref, reactive, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import Buttons from '@/components/Buttons/index.vue';
import { findLabel, objToArr } from '@/utils/tools.ts';
import TagType from '@/views/common/TagType/index.vue';
import { useCommon } from '@/store/useCommon';
import { getUserIptvListApi, getUserCodeListApi } from '@/api/live';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const isIptvAccount = useCommon().userData.roles.some(item => /iptv/ig.test(item)); //区分是否为iptv供应商账号

    console.log('是iptv供应商吗', isIptvAccount); //运营商id vno账号下有一个id，否则就是根据下拉框来选  注意：后续端口用到cpspId时，如果不是vno账号要重新从sessionStorage获取

    const cpspId = isIptvAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
    const selectedIdList = ref([]);
    const selectedList = ref([]);
    const tableRef = ref();
    const tagRef = ref(null);
    const activeTag = ref(undefined); //激活的tag标签，默认0:全部

    const REVIEW_STATUS = {
      '0': 'IPTV',
      '1': 'CODE'
    };
    const isShowAside = ref(true);
    const Tags = computed(() => {
      let common = objToArr(REVIEW_STATUS, 'type', 'name');
      activeTag.value = 0;
      return isShowAside.value ? common : [{
        type: 'close',
        name: '',
        noActive: true,
        icon: 'icon-ic_list'
      }, ...common];
    });
    const typeOptions = [{
      label: t('Model列表'),
      value: 1
    }, {
      label: t('SN组列表'),
      value: 2
    }, {
      label: t('SN列表'),
      value: 3
    }]; // 处理点击事件

    const handleTagClick = tag => {
      // if(tag.type === 'close') return closeAside()
      activeTag.value = tag.type;
    };

    onMounted(() => {});
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '用户',
        prop: 'user',
        widgetType: 'input'
      }, {
        label: 'ID',
        prop: 'iptvId',
        widgetType: 'input',
        controller: () => {
          if (activeTag.value == 0) return true;
        }
      }],
      formData: {
        user: '',
        iptvId: ''
      }
    });

    const handleReset = () => {
      searchParams.value = {
        user: ''
      };
      searchConfig.formData = {
        user: '',
        iptvId: ''
      };
      tableConfig.data = [];
    };

    let searchParams = ref({});

    const handleSearch = formData => {
      for (const key in formData) {
        switch (key) {
          case 'user':
            searchParams.value.user = formData[key];
            break;

          case 'iptvId':
            searchParams.value.iptvId = formData[key];
            break;
        }
      }

      for (let key in searchParams.value) {
        if (searchParams.value[key] === '') {
          delete searchParams.value[key];
        }
      }

      console.log('searchParams', searchParams.value);

      switch (Number(activeTag.value)) {
        case 0:
          getUserIptvList(searchParams.value);
          break;

        case 1:
          getUserCodeList(searchParams.value);
          break;
      }
    };

    const columnConfig = reactive({
      // 在下面watch监听器配置, activeTag默认undefined, 在Tags computed的时候改变这个值激活对应的列表
      columnList: []
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      showPageBar: false,
      headerButtonsList: [{
        label: '',
        key: 0,
        func: () => {},
        cellSlot: true
      }]
    });

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    const sizeChange = size => {
      tableConfig.paginationConfig.limit = size;
    };

    const currentChange = page => {
      tableConfig.paginationConfig.page = page;
    }; //监听激活tag的变化，配置searchConfig和table


    watch(() => activeTag.value, (newVal, oldVal) => {
      tableConfig.data = [];
      searchParams.value = {
        user: ''
      };
      searchConfig.formData = {
        user: '',
        iptvId: ''
      };

      switch (Number(newVal)) {
        case 0:
          columnConfig.columnList = [{
            label: '序号',
            prop: 'no',
            align: 'left',
            width: 100
          }, {
            label: 'ID',
            prop: 'id',
            align: 'left',
            width: 100
          }, {
            label: '用户',
            prop: 'user',
            align: 'left'
          }, {
            label: 'IPTV_ID',
            prop: 'iptvId',
            align: 'left'
          }, {
            label: 'TYPE_ID',
            prop: 'typeId',
            align: 'left'
          }, {
            label: '类型',
            prop: 'type',
            align: 'left',
            formatter: data => findLabel(typeOptions, data)
          }];
          break;

        case 1:
          columnConfig.columnList = [{
            label: '序号',
            prop: 'no',
            align: 'left',
            width: 100
          }, {
            label: 'ID',
            prop: 'id',
            align: 'left',
            width: 100
          }, {
            label: '用户',
            prop: 'user',
            align: 'left'
          }, {
            label: 'IPTV_ID',
            prop: 'iptvId',
            align: 'left'
          }, {
            label: 'Code',
            prop: 'code',
            align: 'left'
          }, {
            label: '账号',
            prop: 'account',
            align: 'left'
          }, {
            label: '密码',
            prop: 'password',
            align: 'left'
          }];
          break;
      }
    }); //获取用户iptv

    const getUserIptvList = async params => {
      loading.value = true;
      const {
        code,
        data
      } = await getUserIptvListApi(params);

      if (code == 0) {
        tableConfig.data = data ? data.map((item, index) => {
          return { ...item,
            no: index + 1
          };
        }) : [];
      }

      loading.value = false;
    }; //获取用户code


    const getUserCodeList = async params => {
      loading.value = true;
      const {
        code,
        data
      } = await getUserCodeListApi(params);

      if (code == 0) {
        tableConfig.data = data ? data.map((item, index) => {
          return { ...item,
            no: index + 1
          };
        }) : [];
      }

      loading.value = false;
    };

    const handleSelectionChange = row => {
      selectedIdList.value = [];
      selectedList.value = [];

      if (row.length > 0) {
        row.forEach(val => {
          selectedIdList.value.push(val.id);
          selectedList.value.push(val);
        });
      } //console.log('选择的频道',selectedChannel.value)

    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        onSearch: handleSearch,
        onReset: handleReset,
        gutter: 50
      }, null, 8, ["form-list", "form-data", "size"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(TagType, {
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick,
        ref_key: "tagRef",
        ref: tagRef
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [_createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [scope.key == 0 ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
          key: 0,
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["buttons-list"])])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref_key: "tableRef",
        ref: tableRef,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config"])], 512)], 512)])])), [[_directive_loading, loading.value]]);
    };
  }

});